import { CommonModule, NgClass, NgFor } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { CanonicalService } from '../../../shared/seo/canonical.service';

@Component({
  selector: 'app-digital-marketing',
  imports: [NgClass,NgFor,CommonModule,RouterModule],
  templateUrl: './digital-marketing.component.html',
  styleUrl: './digital-marketing.component.scss',
   encapsulation: ViewEncapsulation.None  // ✅ Make sure this line is here
})
export class DigitalMarketingComponent implements OnInit {

  constructor(private titleService: Title, private metaService: Meta,private canonicalService: CanonicalService) { }

  ngOnInit(): void {
    // Set page title
    this.titleService.setTitle('Digital Marketing | SEO & Branding by MALtech');

    // Set meta description
    this.metaService.updateTag({
      name: 'description',
      content: 'We boost your online presence and brand visibility with tailored digital marketing services that deliver a unique and impactful digital experience.'
    });

    // Set meta keywords
    this.metaService.updateTag({
      name: 'keywords',
      content: 'Digital, Marketing, Improve'
    });

    // Optional: SEO enhancements
    this.metaService.updateTag({ name: 'robots', content: 'index, follow' });
    this.canonicalService.setCanonicalURL('service/digital-marketing/');

  }

  services = [
    {
      title: 'Search Engine Optimization (SEO)',
      description: "Enhance your website's visibility in search engine results to attract organic traffic.",
      img: 'assets/images/degitalmarketing/seo1.webp',
      bgClass: 'pink-bg'
    },
    {
      title: 'Pay-Per-Click (PPC) Advertising',
      description: 'Drive targeted traffic and maximize your ROI with our expertly managed PPC campaigns.',
      img: 'assets/images/degitalmarketing/ppc1.webp',
      bgClass: 'teal-bg'
    },
    // {
    //   title: 'Social Media Marketing',
    //   description: 'Engage your audience and build a strong brand presence across social media platforms.',
    //   img: 'assets/images/degitalmarketing/icons.webp',
    //   bgClass: 'white-bg'
    // },
    // {
    //   title: 'Search Engine Optimization (SEO)',
    //   description: "Enhance your website's visibility in search engine results to attract organic traffic.",
    //   img: 'assets/images/degitalmarketing/content.webp',
    //   bgClass: 'p'
    // },
    // {
    //   title: 'Pay-Per-Click (PPC) Advertising',
    //   description: 'Drive targeted traffic and maximize your ROI with our expertly managed PPC campaigns.',
    //   img: 'assets/images/degitalmarketing/mailbox.webp',
    //   bgClass: 'teal-bg'
    // },
    {
      title: 'Social Media Marketing',
      description: 'Engage your audience and build a strong brand presence across social media platforms.',
      img: 'assets/images/degitalmarketing/graph1.webp',
      bgClass: 'white-bg'
    }
  ];
  whyMaltech = [
  {
    icon: 'bi-graph-up-arrow',
    title: 'Proven Growth Results',
    description:
      'We deliver measurable outcomes — from 120% organic traffic growth to 5x ROI on ad spend. Every campaign is optimized for performance and scale.'
  },
  {
    icon: 'bi-bar-chart-line',
    title: 'Data-Driven Strategy',
    description:
      'Our marketing decisions are powered by analytics, user behavior insights, and A/B testing to ensure maximum efficiency and consistent improvement.'
  },
  {
    icon: 'bi-megaphone',
    title: 'Creative Brand Impact',
    description:
      'We blend creativity with strategy to craft campaigns that build trust, boost engagement, and position your brand as a market leader.'
  },
  {
    icon: 'bi-shield-check',
    title: 'Transparent & Reliable',
    description:
      'With real-time reporting, clear KPIs, and ethical practices, we ensure full transparency and long-term partnerships you can rely on.'
  }
];


  getStart() {
    const plansSection = document.getElementById('get-start');
    if (plansSection) {
      plansSection.scrollIntoView({ behavior: 'smooth' });
    }
  }


  tools = [
    {
      name: 'Google Analytics',
      logo: 'assets/images/degitalmarketing/google-analytics.webp',
      description: 'Create, send, and analyze email campaigns for effective engagement.'
    },
    {
      name: 'Semrush',
      logo: 'assets/images/degitalmarketing/semrush.webp',
      description: 'Optimize SEO through keyword insights and competitor analysis.'
    },
    {
      name: 'Mailchimp',
      logo: 'assets/images/degitalmarketing/mailchimp.webp',
      description: 'Create, send, and analyze email campaigns to engage with your audience effectively.'
    },
    {
      name: 'Canva',
      logo: 'assets/images/degitalmarketing/canva.webp',
      description: 'Design standout graphics, social posts, and marketing materials.'
    },
    {
      name: 'Google Ads',
      logo: 'assets/images/degitalmarketing/gads.webp',
      description: 'Run targeted ads to reach ideal customers and drive growth.'
    }
  ];

}
